<template>
  <div>
    <!-- 用户新增及活跃趋势 -->
    <Echart
      :options="options"
      :id="cdata.id"
	:style="{ height: curHeight + 'px', width: curWidth + 'px' }"
    ></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart'
import {getSizeByScreen} from '@/utils/index'
export default {
  data () {
    return {
      options: {},
      flag: true,
      curHeight:'',
      curWidth:''
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
	width: {
      type: String,
      default: '600'
    },
	height: {
  type: String,
  default: '200'
	},
  },
  watch: {
    cdata: {
      handler (newData) {
        this.options = {
          title: {
            text: ''
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            data: newData.legendData,
            textStyle: {
              color: "rgba(255,255,255,0.65)",
              fontSize:24
            },
            top: "0%",
            right:"10%",
            itemWidth:30,
            itemHeight:15,
          },
          // grid: {
          //   top: "8%",
          //   width: "88%",
          //   // y: "4%"
          // },
          xAxis: {
            // type: 'category',
            data: newData.category,
            // boundaryGap: true,
            axisLabel: {
              textStyle: {
                color: "rgba(255, 255, 255, 0.65)",
                fontSize:24
              },
            },
            axisLine:{
              lineStyle:{
                color:'transparent'
              } 
            }
          },
          yAxis: newData.yAxis||[
            {
              splitLine: { 
                show: true,
                lineStyle: {
                  color: ["rgba(255, 255, 255, 0.15)"]
                }
              },
              splitNumber: 3, // 横线数
              axisLine: {
                show:false
              },
              position:'left',
              axisLabel: {
                formatter: "{value} ",
                textStyle: {
                  color: "rgba(255, 255, 255, 0.65)",
                  fontSize:20
                }
              },  
              name: newData.yAxisname,
              type:'value'
            },
            {
              splitLine: { 
                show: true,
                lineStyle: {
                  color: ["rgba(255, 255, 255, 0.15)"]
                }
              },
              axisLine: {
                show:false
              },
              position:'right',

              axisLabel: {
                formatter: "{value} ",
                textStyle: {
                  color: "rgba(255, 255, 255, 0.65)",
                  fontSize:16
                }
              }
            }
          ],
          series: newData.series
        }
      },
      immediate: true,
      deep: true
    },
    curWidth:{
      handler (newData) {
        this.curWidth = this.width;
        //适配代码
        // this.curWidth = getSizeByScreen(this.width);
      },
      immediate: true,
      deep: true
    },
    curHeight:{
      handler (newData) {
        this.curHeight = this.height;
        //适配代码
        // this.curHeight = getSizeByScreen(this.height);
      },
      immediate: true,
      deep: true
    }
  },
}
</script>